import { render, staticRenderFns } from "./ThePersonPhoneForm.vue?vue&type=template&id=4723394b&"
import script from "./ThePersonPhoneForm.vue?vue&type=script&lang=js&"
export * from "./ThePersonPhoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports